import { render, staticRenderFns } from "./embedCard.vue?vue&type=template&id=69d4acc0&scoped=true&"
import script from "./embedCard.vue?vue&type=script&lang=js&"
export * from "./embedCard.vue?vue&type=script&lang=js&"
import style0 from "./embedCard.vue?vue&type=style&index=0&id=69d4acc0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d4acc0",
  null
  
)

export default component.exports